import { render, staticRenderFns } from "./AssignVideo.vue?vue&type=template&id=4a339abd&scoped=true&"
import script from "./AssignVideo.vue?vue&type=script&lang=js&"
export * from "./AssignVideo.vue?vue&type=script&lang=js&"
import style0 from "./AssignVideo.vue?vue&type=style&index=0&id=4a339abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a339abd",
  null
  
)

export default component.exports